import * as messaging from "../../core/messaging/front";
import * as filters from "../../filters/shared";
import * as ewe from "@eyeo/webext-ad-filtering-solution/ui";
function start() {
    if (self.modulesAsGlobal) {
        return;
    }
    self.modulesAsGlobal = { messaging, filters, ewe };
}
start();
